/* eslint-disable react/require-extension */
// Bootstrap environment

const onWindowIntl = () => {
  require('babel-polyfill');
  window.Promise = require('../common/configureBluebird');

  // App locales are defined in src/server/config.js
  // Adding icelandic
  const intl = require('intl');
  window.DateTimeFormat = intl.DateTimeFormat;
  require('intl/locale-data/jsonp/is');
  require('./main');
};

// github.com/andyearnshaw/Intl.js/#intljs-and-browserifywebpack
if (!window.Intl) {
  require.ensure([
    'intl',
    'intl/locale-data/jsonp/is.js',
  ], (require) => {
    require('intl');
    require('intl/locale-data/jsonp/is.js');

    onWindowIntl();
  });
} else {
  onWindowIntl();
}



// WEBPACK FOOTER //
// ./src/browser/index.js